module.exports = __webpack_public_path__ + "assets/pre-redpacket-success-b748be23.png";